module.exports = __webpack_public_path__ + "img/logo_sowos_wealth_white.a05c82a7.svg";